import store, { showToastWithType } from '../../../../core/store';
import { FORMS_WIDGET_ERROR_TOAST_TYPE } from '../../constants/reentry-planning.constants';

/**
 * Shows a red (filled `severity="error"`) app toast. Sets message and variant in one action so
 * the toast never inherits a previous success variant.
 *
 * @param {string} message - User-facing copy
 */
export const notifyFormsWidgetError = (message) => store.dispatch(showToastWithType(message, FORMS_WIDGET_ERROR_TOAST_TYPE));
